import { create } from 'zustand';

import { SelectedAddOns } from '@/components/shared/components/add-to-cart-button/add-to-cart-modal/type';
interface RemovedAddon {
  id: string;
  title: string;
}
interface DropdownStateItem {
  id: string;
  show: boolean;
}

interface AddonsStore {
  addons: SelectedAddOns;
  setAddons: (addons: SelectedAddOns) => void;
  newSelectedAddons: SelectedAddOns;
  setNewSelectedAddons: (newSelectedAddons: SelectedAddOns) => void;
  selectedAddons: SelectedAddOns;
  setSelectedAddons: (selectedAddons: SelectedAddOns) => void;
  removedAddons: RemovedAddon[];
  setRemovedAddons: (removedAddons: RemovedAddon[]) => void;
  dropdownStates: DropdownStateItem[];
  setDropdownState: (dropdownStates: DropdownStateItem[]) => void;
}

export const useAddonsStore = create<AddonsStore>((set) => ({
  addons: {},
  setAddons: (addons: SelectedAddOns) => set({ addons }),
  selectedAddons: {},
  setSelectedAddons: (selectedAddons: SelectedAddOns) => set({ selectedAddons }),
  newSelectedAddons: {},
  setNewSelectedAddons: (newSelectedAddons: SelectedAddOns) => set({ newSelectedAddons }),
  removedAddons: [],
  setRemovedAddons: (removedAddons: RemovedAddon[]) => set({ removedAddons }),
  dropdownStates: [],
  setDropdownState: (dropdownStates: DropdownStateItem[]) => set({ dropdownStates }),
}));
